import React from 'react'
import Header from '../../../../../component/layout/LandingHeader'
import Footer from '../../../../../component/layout/Footer'

export default function CookiePolicies() {
    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">

                <div className="content-section section-padding">
                    <div className="container">
                        {/*Page Can be used in admin Dashboard, Copy From here*/}
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="text-wrap content-page-wrapper">
                                    <h2 className='heading fs-38 fw-700'>Cookie Policy for ClearView</h2>
                                    <div className="text-part">
                                        <p><strong>Effective Date:</strong> 1st Feb 2024</p>


                                        <p>Welcome to ClearView by Digital Apple. We are committed to protecting your privacy and ensuring transparency in how we collect and use data. This Cookie Policy explains the use of cookies and similar technologies on our ClearView platform.</p>
                                        <h3>What are Cookies?</h3>
                                        <p>Cookies are small text files placed on your device when you visit websites. They help in remembering your preferences, enhancing user experience, and tailoring content and advertisements to suit your interests.</p>
                                        <h3>How ClearView Uses Cookies</h3>
                                        <p>At ClearView, cookies play a vital role in:</p>
                                        <ul>
                                            <li><strong>Enhancing User Experience:</strong> Remembering your settings and preferences for a more personalized experience.</li>
                                            <li><strong>Security:</strong> Keeping your ClearView account secure as you navigate through our tool.</li>
                                            <li><strong>Performance Insights:</strong> Understanding tool usage to improve our services and features.</li>
                                            <li><strong>Marketing:</strong> Analyzing user interaction to optimize our marketing strategies and provide relevant content.</li>

                                        </ul>
                                        <h3>Types of Cookies</h3>
                                        <p>Below, we outline various types of cookies. Currently, ClearView does not use any cookies. However, this could change in the future. We encourage you to regularly review this policy.</p>
                                        <ol>
                                            <li><strong>Essential Cookies:</strong> Necessary for the core functionality of ClearView, enabling secure login and session management.</li>
                                            <li><strong>Performance Cookies:</strong> Gather data on how users interact with ClearView, helping us improve performance.</li>
                                            <li><strong>Functionality Cookies:</strong> Remember user preferences and settings, enhancing your ClearView experience.</li>
                                            <li><strong>Advertising Cookies:</strong> Deliver tailored advertising based on your interests and previous interactions with our tool.</li>
                                        </ol>

                                        <h3>Your Choices Regarding Cookies</h3>
                                        <p>You have control over your cookie preferences. Most web browsers allow you to manage cookie settings, including accepting, rejecting, or deleting cookies. Please note that if you choose to reject cookies, some functionalities of ClearView might be limited.</p>


                                        <h3>Changes to This Cookie Policy</h3>
                                        <p>ClearView may update this Cookie Policy in response to changing technologies, business practices, or regulatory changes. We encourage you to review this policy periodically to stay informed about how we use cookies.</p>


                                        <h3>Contact Us</h3>
                                        <p>For any questions or concerns about our cookie practices, please reach out to us at: <a href="mailto:support@clearview360.ai">support@clearview360.ai</a></p>

                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}
